import React, { Component } from 'react';
import {  CardBody } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Button from '@material-ui/core/Button';


class ProceduresOne extends Component {
    constructor(props) {
        super(props);

        this.state = {
            print: '',
            studies: '',
            observations: ''
        }
    }

    componentDidMount() {

    }

    handlerPrint = (print) => {
        this.setState({ print: print });
    }

    handlerStudies = (studies) => {
        this.setState({ studies: studies });
    }

    handlerObservations = (observations) => {
        this.setState({ observations: observations });
    }

    render() {

        return (
            <CardBody>
            <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
                <div className="card__title">
                    <h5 className="bold-text">Procedimiento Nuclear</h5>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Impresión diagnostica:</span>
                    <div className="form__form-group-field">
                        <Field
                            name="textarea-impresion-"
                            component="textarea"
                            type="text"
                            onChange={(e) => {
                                this.handlerPrint(e.target.value)
                            }}
                        />
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Estudios Anteriores:</span>
                    <div className="form__form-group-field">
                        <Field
                            name="textarea-impresion-"
                            component="textarea"
                            type="text"
                            onChange={(e) => {
                                this.handlerStudies(e.target.value)
                            }}
                        />
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Observaciones: </span>
                    <div className="form__form-group-field">
                        <Field
                            name="textarea-impresion-"
                            component="textarea"
                            type="text"
                            onChange={(e) => {
                                this.handlerObservations(e.target.value)
                            }}
                        />
                    </div>
                </div>
                <div className="form__form-group">
                <Button
                    style={{ marginTop: 20 }}
                    variant="contained"
                    color="primary"                    
                > 
                Guardar Procedimiento
                </Button>
                </div>
            </div>
        </CardBody>);
    }
}

export default reduxForm({
    form: 'proceduresone_form', // a unique identifier for this form
  })(ProceduresOne);